import { useMemo } from 'react'

export function useLinkFormatter(url: string) {
  const normalizedUrl = useMemo(() => {
    // Remove leading/trailing whitespace
    const normalized = url.trim()
    // Add protocal if missing
    if (/^https?:\/\//.test(normalized) == false) {
      return 'http://' + normalized
    } else return normalized
  }, [url])

  return normalizedUrl
}
